import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import { CategoryDetailPage } from "@/components/features/FormBuilder/Assignments/CategoryDetailPage/CategoryDetailPage";
import type { VisitCategory } from "@/api/form-builder-assignments/formBuilderAssignments.types";

const categoryDetailSearchSchema = z.object({
  entityId: z.string().optional(),
  entityName: z.string().optional(),
  clientId: z.string().optional(),
  clientName: z.string().optional(),
  brandId: z.string().optional(),
  brandName: z.string().optional(),
  tradeId: z.coerce.number().optional(),
  tradeName: z.string().optional(),
  subtradeId: z.coerce.number().optional(),
  subtradeName: z.string().optional(),
  formType: z.string().optional(),
});

export const Route = createFileRoute("/form-builder/_formBuilderLayout/assignments/$category")({
  validateSearch: categoryDetailSearchSchema,
  component: CategoryDetailRoute,
});

function CategoryDetailRoute() {
  const { category } = Route.useParams();
  const search = Route.useSearch();

  return <CategoryDetailPage category={category as VisitCategory} search={search} />;
}
